import React from 'react';
import PropTypes from 'prop-types';

import Header from '../components/Header';
import Footer from '../components/Footer';

import '../node_modules/bootstrap/dist/css/bootstrap.css';


import '../static/less/styles.scss';

class Template extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <div>
        <Header />
        {children}
        <Footer />
      </div>
    );
  }
}

Template.propTypes = {
  children: PropTypes.any,
};

export default Template;



// WEBPACK FOOTER //
// ./_template.jsx